export default "__VITE_ASSET__D5mVP3VD__"